import { tVariants } from '../../style-system';

const menuGroupStyles = tVariants({
    base: 'clickable-target px-1 py-2 pb-1 z-[0] relative before:-mx-1 clickable-bg-surface-muted clickable-rounded-md',
});

export { menuGroupStyles };
